module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/query-form/query-form.component.css
// module id = ./src/app/query-form/query-form.component.css
// module chunks = main